import React from 'react'
import styles from './RichTextDisplay.module.scss'
import { sanitizeRichTextHtml } from '@ztechapps/common.utils'

export const RichTextDisplay = ({
  contentHtml,
  style,
  as,
  className,
  trustedSource = false,
}: {
  contentHtml: string
  style?: React.CSSProperties
  as?: React.ElementType
  className?: string
  // Default is FALSE — every caller is sanitised unless it opts out explicitly and visibly at
  // its own call site. `contentHtml` reaches this component from all kinds of sources (first-party
  // editors, system templates, but also attacker-reachable inbound email), and this component has
  // no way to tell them apart, so an unsafe default would let a future call site render attacker
  // HTML raw just by forgetting a flag. Pass `trustedSource` only for content this app itself
  // authored (an admin's own editor, a static content string in the repo, a system-generated
  // template) — never for anything that entered the system from outside it.
  trustedSource?: boolean
}) => {
  const Component = as ?? 'div'
  const html = trustedSource ? contentHtml : sanitizeRichTextHtml(contentHtml)

  return <Component style={style} className={className ?? styles.genHtml} dangerouslySetInnerHTML={{ __html: html }} />
}
